import { type PromoCodeCreatePostBody, createRandomString } from "@repo/common";

import { type PromoCodesCreateFormType } from "./PromoCodesCreate.types";

const generateUniqueCodes = (prefix: string, amount: number): string[] => {
  const codes = new Set<string>();

  while (codes.size < amount) {
    codes.add(`${prefix}-${createRandomString(10)}`);
  }

  return Array.from(codes);
};

export const mapFormSchemaToServerSchema = (formData: PromoCodesCreateFormType): PromoCodeCreatePostBody => {
  const codes = generateUniqueCodes(formData.codePrefix, formData.amountCodes);

  return codes.map((code) => ({
    code,
    type: formData.type,
    codeValue: formData.codeValue,
    expires_on: formData.expiresOn,
  }));
};
